module.exports = __webpack_public_path__ + "media/images/trash-can-f2f3a870352bad7ebedfefab2d510042.png";